import Input from './src/main'

Input.install = function (Vue) {
  Vue.component(Input.name, Input)
}

export default Input
